import CourseAdmin from './CourseAdmin';

export default CourseAdmin;
